import { StepBlockSetup } from './components/steps/Step.BlockSetup';
import { StepBlockWysiwyg } from './components/steps/Step.BlockWysiwyg';
import { StepInlineAttachment } from './components/steps/Step.InlineAttachment';
import { StepLibrary } from './components/steps/Step.Library';
import { StepStart } from './components/steps/Step.Start';
import type { BlockCreatorStep, BlockCreatorStepId } from './types';

// Exit must not stagger height behind opacity: an invisible box pushing siblings around after
// the fade completes reads as end-of-animation lag.
export const animationProps = {
  initial: {
    height: 0,
    opacity: 0,
  },
  animate: {
    height: 'auto',
    opacity: 1,
    transition: {
      height: { duration: 0.4 },
      opacity: { duration: 0.35, delay: 0.15 },
    },
  },
  exit: {
    height: 0,
    opacity: 0,
    transition: { duration: 0.25 },
  },
  transition: {
    ease: 'easeInOut' as const,
  },
};

export const BLOCK_CREATOR_STEPS: Record<BlockCreatorStepId, BlockCreatorStep> = {
  start: {
    component: StepStart,
  },
  'library-block': {
    component: () => <StepLibrary stepId="library-block" />,
    prevStepId: 'start',
  },
  'library-clause': {
    component: () => <StepLibrary stepId="library-clause" />,
    prevStepId: 'start',
  },
  block: {
    component: StepBlockSetup,
    prevStepId: 'start',
  },
  wysiwyg: {
    component: StepBlockWysiwyg,
    prevStepId: 'block',
  },
  'inline-attachment': {
    component: StepInlineAttachment,
    prevStepId: 'start',
  },
};
